import React, { useState, useEffect, useRef } from 'react';
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { Container, Row, Col } from 'reactstrap';
import { moduleMargins } from '../../Constants';


const renderContent = (content) => {
  return { __html: content };
}

function EirLeftMenuRightContent(props) {
  let parentRef = props.parentContent;
  let getParentFolder = props.folderName;
  let parentContentArray = [];
  let getCount = getParentFolder.split("/");
  Object.values(parentRef).forEach(value => {
    parentContentArray.push({ "filepath": value.fileName, "displayname": value.displayName, "sortorder": value.sortOrder });
  });
  let firstChildArray = [];
  for (var i = 0; i < parentContentArray.length; i++) {
    if (getCount.length + 1 == parentContentArray[i].filepath.split("/").length) firstChildArray.push(parentContentArray[i]);
  }

  /* this is for setting het chevron on the left menu across sites - lb, smb. consumer 
  have three variables for default, on click and hover - what should be the chevron class
  */
  let setChevronDefault, setChevronClick, setChevronHoverDown, setChevronHoverUp;
  setChevronHoverUp = "icon-arrowup--white";
  setChevronHoverDown = "icon-arrowdown--white";
  (location.pathname.indexOf("/business/") >= 0) || (location.pathname.indexOf("/helpandsupport/") >= 0) ?
    (setChevronDefault = "icon-arrowdown--purple", setChevronClick = "icon-arrowup--purple")
    :
    (setChevronDefault = "icon-arrowdown--black", setChevronClick = "icon-arrowup--black")



  //manage the hover, mouseout, click and expand collapse states for the chevron across sites
  const lmOnclick = (e) => {
    // if (e.target.classList.value.indexOf("lm-collapsible") >= 0) {
    //   if (e.target.parentNode.nextElementSibling.classList.value.indexOf("collapse") < 0) {
    //     e.target.parentNode.nextElementSibling.classList.replace("expand", "collapse");
    //     e.target.classList.add(setChevronHoverDown);
    //     e.target.classList.remove(setChevronHoverUp);
    //   }
    //   else {
    //     e.target.parentNode.nextElementSibling.classList.replace("collapse", "expand");
    //     e.target.classList.add(setChevronHoverUp);
    //     e.target.classList.remove(setChevronHoverDown);
    //   }
    // }
    // //remove the default chevron when active item is selected - 
    // if (e.target.parentNode.parentNode.classList.value.indexOf("active-lm") >= 0) {
    //   e.target.classList.remove(setChevronDefault);
    // }
    const submenu = e.target.parentNode.nextElementSibling;

if (submenu.classList.value.indexOf("collapse") < 0) {
  submenu.classList.replace("expand", "collapse");
  e.target.setAttribute("aria-expanded", "false");
  e.target.classList.add(setChevronHoverDown);
  e.target.classList.remove(setChevronHoverUp);
} else {
  submenu.classList.replace("collapse", "expand");
  e.target.setAttribute("aria-expanded", "true");
  e.target.classList.add(setChevronHoverUp);
  e.target.classList.remove(setChevronHoverDown);
}

  }

  //hover not applicable for active item expanded - the second && condition is for the same
  const lmHover = (e) => {
    if ((e.target.classList.value.indexOf("lm-collapsible") >= 0 || e.target.classList.value.indexOf("lm-link") >= 0) && e.target.parentNode.parentNode.classList.value.indexOf("active-lm") < 0) {
      var targetChevron = (e.target.classList.value.indexOf("lm-collapsible") >= 0) ? e.target.classList : e.target.nextElementSibling.classList;
      if (targetChevron.value.indexOf(setChevronDefault) >= 0) {
        targetChevron.replace(setChevronDefault, setChevronHoverDown);
      }
      if (targetChevron.value.indexOf(setChevronClick) >= 0) {
        targetChevron.replace(setChevronClick, setChevronHoverUp);
      }
    }
  }

  //mouseout not applicable for active item expanded - the second && condition is for the same
  const lmMouseout = (e) => {
    if ((e.target.classList.value.indexOf("lm-collapsible") >= 0 || e.target.classList.value.indexOf("lm-link") >= 0) && e.target.parentNode.parentNode.classList.value.indexOf("active-lm") < 0) {
      var targetChevron = (e.target.classList.value.indexOf("lm-collapsible") >= 0) ? e.target.classList : e.target.nextElementSibling.classList;
      if (targetChevron.value.indexOf(setChevronHoverDown) >= 0) {
        targetChevron.replace(setChevronHoverDown, setChevronDefault);
      }
      if (targetChevron.value.indexOf(setChevronHoverUp) >= 0) {
        targetChevron.replace(setChevronHoverUp, setChevronClick);
      }
    }
  }

const syncChevronWithSubmenu = () => {
  const chevrons = document.querySelectorAll(".lm-collapsible");

  chevrons.forEach(chevron => {
    if (!chevron.parentNode) return;

    const submenu = chevron.parentNode.nextElementSibling;
    if (!submenu) return;

    if (submenu.classList.contains("expand")) {
      chevron.classList.add(setChevronHoverUp);
      chevron.classList.remove(setChevronHoverDown);
      chevron.setAttribute("aria-expanded", "true");
    } else {
      chevron.classList.add(setChevronHoverDown);
      chevron.classList.remove(setChevronHoverUp);
      chevron.setAttribute("aria-expanded", "false");
    }
  });
};
  useEffect(() => {
    //initially hide the comp that needs to be loaded in the RHS and later after adding the appendChild to RHS change - show the component
    if ((props.rhsCompID != "" && document.querySelector("#" + props.rhsCompID) != null) && location.href.indexOf("/opencms/opencms/") < 0) document.querySelector("#" + props.rhsCompID).style.cssText = "display:none";
    if (location.href.indexOf("/opencms/opencms/") < 0) {
      setTimeout(() => {
        //add class to the selected menu item 
        let selectedLMItem = document.querySelector("#" + location.pathname.replaceAll("/", "_"));
        //if handles teh parent level
        if (selectedLMItem != null) {
          selectedLMItem.classList.add("active-lm");
        }
        // else handles the child levels
        else {
          var childItem = document.querySelectorAll(".child-items");
          for (var j = 0; j < childItem.length; j++) {
            if (childItem[j].children.length > 0) {
              for (var k = 0; k < childItem[j].children.length; k++) {
                if (childItem[j].children[k].getAttribute("data-parent") === location.pathname.replaceAll("/", "_")) {
                  childItem[j].children[k].style.cssText = "text-decoration:underline";
                  childItem[j].parentNode.classList.add("active-lm");
                  childItem[j].parentNode.querySelector(".chevron").click()
                }
              }

            }
          }
        }
        // fill the RHS of the body with the respective component provided in opencms
        // document.getElementById(props.rhsCompID).style.cssText = "display:none";
        // document.getElementById("rhs").innerHTML = document.getElementById(props.rhsCompID).innerHTML;
        var getRHSCtr = document.querySelector("#rhs");
        getRHSCtr.appendChild(document.getElementById(props.rhsCompID));
        getRHSCtr.children[0].style.cssText = "display:block";

        //click the current active left menu item when page loads
        if (selectedLMItem != null && selectedLMItem.querySelector(".child-items").children.length > 0) selectedLMItem.querySelector(".chevron").click();

        // make the selected item as the first item of the left menu
        var getLMCtr = document.querySelector(".leftmenu-ctr");
        for (var i = 0; i < getLMCtr.children.length; i++) {
          if (getLMCtr.children[i].classList.value.indexOf("active-lm") >= 0) {
            getLMCtr.insertBefore(getLMCtr.childNodes[i], getLMCtr.childNodes[1]);
          }
        }
        let getLMItem = document.querySelectorAll(".left-menu-list-item");
        if (getLMItem.length > 0) {
          for (var i = 0; i < getLMItem.length; i++) {
            getLMItem[i].innerHTML = getLMItem[i].innerHTML.replaceAll("&amp;#039;", "'");
          }
        }
        syncChevronWithSubmenu();
      }, 1000);
    }

    //dont show chevrons for the items that do not have children
    let getLMHeading = document.querySelectorAll(".left-menu-item");
    for (let i = 0; i < getLMHeading.length; i++) {
      if (getLMHeading[i].querySelector(".collapse").children.length < 1) {
        getLMHeading[i].querySelector(".toggle-left-menu").classList.remove("lm-collapsible");
        getLMHeading[i].querySelector(".toggle-left-menu").classList.remove("icon-arrowdown--purple");
      }
    }

    //manage the hover, mouseout, click and expand collapse states for the chevron across sites
    document.addEventListener("click", lmOnclick)

    //hover not applicable for active item expanded - the second && condition is for the same
    document.addEventListener("mouseover", lmHover)

    //mouseout not applicable for active item expanded - the second && condition is for the same
    document.addEventListener("mouseout", lmMouseout)

    // remove the eventListeners 
    return () => { window.removeEventListener("click", lmOnclick), window.removeEventListener("mouseover", lmHover), window.removeEventListener("mouseout", lmMouseout) }

  }, [])
  
  let [marginDesktop, marginMobile] = moduleMargins(props.MarginDT, props.MarginMobile);
  const leftMenuRightContentProps = {
      marginClass : (!isMobile) ? marginDesktop : marginMobile,
  }

  return (
    <div className={`container eir-leftmenu-rightcontent ${leftMenuRightContentProps.marginClass}`} > {/* added spacing module */}
      <div className={(!isMobile) ? "col-12 row" : "col-12 d-flex"}>
        <div id="lhs" className={(isTablet) ? 'col col-4' : 'col col-3'}>
          <div className="leftmenu-ctr">
            {(props.lhsTopLinkText != "" && props.lhsTopLinkPath != "") &&
              <p className="support-home-link eir-subtitle3">
                <a className="support-home-link-a-link" href={props.lhsTopLinkPath} >{props.lhsTopLinkText} </a>
                {/* <span className={"chevron toggle-left-menu lm-collapsible " + setChevronDefault}></span> */}
                <span
                    className={"chevron toggle-left-menu lm-collapsible " + setChevronDefault}
                    role="button"
                    tabIndex={0}
                    aria-expanded="false"
                    aria-controls="left-menu"
                  ></span>
              </p>
            }
            {
              firstChildArray.map((name, ind) => (
                <div className="left-menu-item" key={ind} id={name.filepath.replaceAll("/", "_")}>
                  <p className="eir-subtitle3">
                    <a className="lm-link" href={name.filepath}>{name.displayname} </a>
                    {/* <span className={"chevron toggle-left-menu lm-collapsible " + setChevronDefault}></span> */}
                    <span
                      className={"chevron toggle-left-menu lm-collapsible " + setChevronDefault}
                      role="button"
                      tabIndex={0}
                      aria-expanded="false"
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          e.target.click();
                        }
                      }}
                    ></span>

                  </p>
                  <ul className="child-items collapse">
                    {
                      parentContentArray
                      .sort((a, b) => a.sortorder > b.sortorder ? 1 : -1)
                      .map((sub, subindex) =>
                        ((sub.filepath != name.filepath) && (sub.filepath.indexOf(name.filepath) > -1)) ?
                          <li data-parent={sub.filepath.replaceAll("/", "_")} key={subindex}><a className="left-menu-list-item" href={sub.filepath}>{sub.displayname}</a></li> : ''
                      )
                    }
                  </ul>
                </div>
              ))
            }
            {(props.lhsBottomLink.toLowerCase() != "hide") &&
              <a href={props.lhsBottomLinkPath}>
                <h4 className="lhs-bottom-link col-12">
                  <img className="col-6" src={props.lhsBottomLinkImage} alt="" />
                  <a className="col-6" href={props.lhsBottomLinkPath} >{props.lhsBottomLinkText}
                    {/* <span className={"chevron toggle-left-menu lm-collapsible " + setChevronDefault}></span> */}
                     <span
                          className={"chevron toggle-left-menu lm-collapsible " + setChevronDefault}
                          role="button"
                          tabIndex={0}
                          aria-expanded="false"
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              e.target.click();
                            }
                          }}
                        ></span>

                  </a>
                </h4>
              </a>
            }
          </div>
        </div>
        <div className={(!isMobile) ? (isTablet) ? "col col-8" : "col col-9" : "w-100"} id="rhs">
        </div>
      </div>
    </div>
  );

}
export default EirLeftMenuRightContent;